import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DeviceCondition_Interface, Empty_DeviceCondition_Interface } from 'src/app/Interface/DeviceCondition_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceConditionService } from 'src/app/Service/Device/DeviceCondition.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-DeviceConditionForm',
  templateUrl: './DeviceConditionForm.component.html',
  styleUrls: ['./DeviceConditionForm.component.scss']
})
export class DeviceConditionFormComponent implements OnInit {

  Token:String=""

  constructor(
    private DeviceCondition_Service:DeviceConditionService,
    private Nav_Service:NavService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.AddNewDeviceCondition=new FormGroup({
      id :new FormControl(),
      takhir:new FormControl(null,Validators.required),
      tajil:new FormControl(null,Validators.required),
      brabar:new FormControl(null,Validators.required),
      day:new FormControl(null,Validators.required),
    })


    this.Nav_Service.CheckValidPage(this.Token,2183).subscribe(
      data=>{

      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }


  //#region  Form Add

  AddNewDeviceCondition:FormGroup;

  get_Form_takhir(){
    return this.AddNewDeviceCondition.get('takhir') as FormControl;
  }
  get_Form_tajil(){
    return this.AddNewDeviceCondition.get('tajil') as FormControl;
  }
  get_Form_brabar(){
    return this.AddNewDeviceCondition.get('brabar') as FormControl;
  }
  get_Form_day(){
    return this.AddNewDeviceCondition.get('day') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitAddNewDeviceCondition(){
    var Record:DeviceCondition_Interface =Empty_DeviceCondition_Interface()
    Record.id=0
    Record.takhir=Number(this.get_Form_takhir().value)
    Record.tajil=Number(this.get_Form_tajil().value)
    Record.brabar=Number(this.get_Form_brabar().value)
    Record.day=Number(this.get_Form_day().value)
    this.InProccessing=true
    this.DeviceCondition_Service.AddDeviceCondition(Record,this.Token).subscribe(
      data=>{
        this.InProccessing=false
        if(data.id==-2){
          this.Alertify_Service.ErrorMessage("The entered title already exists in the list")
        }
        else{
          this.AddNewDeviceCondition.reset()
          this.Alertify_Service.SuccessMessage("The information was registered successfully")
        }
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

}
